import { stylesheet } from 'typestyle';
import { colors } from '../../assets/styles';
import { translate } from 'csx';

const styles = stylesheet({
  callInProcessLayout: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  },
  callInProcessBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    background: colors.black,
    opacity: 0.8,
  },
  callScreenContainer: {
    top: '50%',
    left: '50%',
    bottom: 'auto',
    right: 'auto',
    transform: translate('-50%', '-50%'),
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid white',
    borderRadius: 10,
    maxWidth: 320,
    width: '80%',
    background: colors.white,
  },
  displayFlexWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 30,
  },
  timeWrapper: {
    fontSize: 20,
    margin: '30px 0 15px 0',
    textAlign: 'center',
  },
  residentName: {
    marginBottom: 20,
  },
  row: {
    flexDirection: 'row',
    margin: '30px 0',
    textAlign: 'center',
    alignItems: 'center',
  },
  callscreenButton: {
    width: 60,
    height: 60,
    padding: 0,
    alignItems: 'center',
    borderRadius: '50%',
    margin: '0 20px',
    background: 'none',
    border: '1px solid #757575',
    fontSize: 20,
  },
  endCall: {
    backgroundColor: 'red',
    border: 'none',
  }
});

export default styles;
